import React from 'react';

/** Positioned readout used by every hover layer. Values lead, labels follow. */
export default function Tooltip({ x, y, width, title, rows = [] }) {
  if (!rows.length && !title) return null;
  const flip = width && x > width * 0.62;
  const style = {
    left: flip ? undefined : x + 14,
    right: flip ? width - x + 14 : undefined,
    top: Math.max(0, y - 12),
  };
  return (
    <div className="le-tooltip" style={style} role="status">
      {title ? <div className="le-tooltip-title">{title}</div> : null}
      {rows.map((r) => (
        <div key={r.id || r.label} className="le-tooltip-row">
          {r.color ? <span className="le-tooltip-key" style={{ '--swatch': r.color }} /> : <span className="le-tooltip-key le-tooltip-key-none" />}
          <span className="le-tooltip-value">{r.value}</span>
          <span className="le-tooltip-label">{r.label}</span>
        </div>
      ))}
    </div>
  );
}
